<template>
  <v-row class="min-height-row">
    <v-checkbox
      v-model="isSelected"
      :indeterminate="selectionVal === 1"
      hide-details
      v-on:change="valUpdated"
      :label="label"
      class="py-0"
    >
    </v-checkbox>
  </v-row>
</template>

<script>
export default {
  model: {
    prop: 'selectionVal',
    event: 'selectionValEv',
  },
  props: {
    label: { typeof: String },
    selectionVal: { typeof: Number },
    fullPath: { typeof: String },
  },
  data() {
    return {
      isSelected: false,
    };
  },
  watch: {
    selectionVal(val) {
      if (val === 2) {
        this.isSelected = true;
      } else {
        this.isSelected = false;
      }
    }
  },
  mounted() {
    this.isSelected = this.selectionVal === 2;
  },
  methods: {
    valUpdated(val) {
      if (val) {
        this.$emit('selectionValEv', 2, this.label);
      } else {
        this.$emit('selectionValEv', 0, this.label);
      }
    },
  },
};
</script>

<style scoped>
.min-height-row {
  min-height: 40px;
}
</style>
